module.exports = __webpack_public_path__ + "img/40_38_032_750.bda0305e.jpg";